// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BarTop_barTop__mwZDf {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: var(--color-secundario);
  font-size: var(--font-chica);
}

@media (max-width: 768px) {
  .BarTop_barTop__mwZDf {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/BarTop/BarTop.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,8BAAA;EACA,4BAAA;AACJ;;AAEA;EACI;IACI,aAAA;EACN;AACF","sourcesContent":[".barTop{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: white;\n    color: var(--color-secundario);\n    font-size: var(--font-chica);\n}\n\n@media (max-width: 768px) {\n    .barTop{\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"barTop": `BarTop_barTop__mwZDf`
};
export default ___CSS_LOADER_EXPORT___;
